import Vue from 'vue'
import { hostsConfig } from 'init/config'

import withRender from './summary-dim-select-image.html'
import './summary-dim.scss'
import './summary-dim-select-image.scss'

export default withRender(Vue.extend({
  props: {
    label: { type: String },
    values: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    imageUrl(imageId) {
      // tslint:disable-next-line:max-line-length
      return `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}/custom-dim/${hostsConfig.siteKey}/${imageId}.png`
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-summary/summary-dim-select-image.ts